

























import Vue from 'vue'
import * as R from 'ramda'
import { mapActions, mapGetters } from 'vuex'
import { ModuleNames } from '@/store/module-names'
import { ActionNames, GetterNames } from '@/store/modules/patient-with-detailed-reports/keys'
import moment from 'moment-timezone'
import { OFFSET_HOURS_TIMESTAMP } from '@/components/patient-stats/graphs/mapping-chart-options/constants'
import { FlatPatientWithDetailedReports } from '@/store/modules/patient-with-detailed-reports/getters'
import PatientStatsDetailedActivityCharts from '@/components/patient-stats/graphs/detailed-reports/PatientStatsDetailedActivityCharts.vue'
import PatientStatsDetailedMaintenanceInhalerCharts from '@/components/patient-stats/graphs/detailed-reports/PatientStatsDetailedMaintenanceInhalerCharts.vue'
import PatientStatsDetailedRescueInhalerCharts from '@/components/patient-stats/graphs/detailed-reports/PatientStatsDetailedRescueInhalerCharts.vue'
import PatientStatsDetailedSleepCharts from '@/components/patient-stats/graphs/detailed-reports/PatientStatsDetailedSleepCharts.vue'
import PatientStatsDetailedTab from '@/components/patient-stats/PatientStatsDetailedTab.vue'
import { PATIENT_STATS_DETAILED_REPORT_TYPES } from '@/components/patient-stats/constants'
import { PatientWithStatsActionNames, PatientWithStatsGetterNames } from '@/store/modules/patient-with-stats/keys'
import { FlatPatientWithStats } from '@/store/modules/patient-with-stats/getters'

export default Vue.extend({
  components: {
    PatientStatsDetailedActivityCharts,
    PatientStatsDetailedMaintenanceInhalerCharts,
    PatientStatsDetailedRescueInhalerCharts,
    PatientStatsDetailedSleepCharts,
    PatientStatsDetailedTab,
  },
  inheritAttrs: false,
  props: {
    startTimestamp: {
      type: Number,
      required: true,
    },
    endTimestamp: {
      type: Number,
      required: true,
    },
    patientId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isInitialized: false,
      activeTab: PATIENT_STATS_DETAILED_REPORT_TYPES.ACTIVITY.key,
    }
  },
  computed: {
    ...mapGetters(ModuleNames.patientWithDetailedReports, [GetterNames.patientWithDetailedReports]),
    ...mapGetters(ModuleNames.patientWithStats, [PatientWithStatsGetterNames.PatientWithStats]),
    patientWithDetailedReports(): FlatPatientWithDetailedReports {
      return this[GetterNames.patientWithDetailedReports].find(patientWithDR => patientWithDR.id === this.patientId)
    },
    patientWithStats(): FlatPatientWithStats {
      return this[PatientWithStatsGetterNames.PatientWithStats].find(
        patientWithStats => patientWithStats.id === this.patientId
      )
    },
    chartComponent() {
      switch (this.activeTab) {
        case PATIENT_STATS_DETAILED_REPORT_TYPES.SLEEP.key:
          return 'PatientStatsDetailedSleepCharts'
        case PATIENT_STATS_DETAILED_REPORT_TYPES.ACTIVITY.key:
          return 'PatientStatsDetailedActivityCharts'
        case PATIENT_STATS_DETAILED_REPORT_TYPES.MAINTENANCE_INHALER.key:
          return 'PatientStatsDetailedMaintenanceInhalerCharts'
        case PATIENT_STATS_DETAILED_REPORT_TYPES.RESCUE_INHALER.key:
          return 'PatientStatsDetailedRescueInhalerCharts'
        default:
          return ''
      }
    },
    isNoData(): boolean {
      const data = [
        R.pathOr([], ['activityReport', 'casualWalkSteps'], this.patientWithDetailedReports).length,
        R.pathOr([], ['activityReport', 'walkDurations'], this.patientWithDetailedReports).filter(dp => dp.value !== 0)
          .length,
        R.pathOr([], ['inhalersReport', 'inhalerUsages'], this.patientWithDetailedReports).reduce(
          (acc, usage) => acc + usage.dataPoints.length,
          0
        ),
        R.pathOr([], ['inhalersReport', 'nightInhalerUsages'], this.patientWithDetailedReports).reduce(
          (acc, usage) => acc + usage.dataPoints.length,
          0
        ),
        R.pathOr([], ['inhalersReport', 'overUsages'], this.patientWithDetailedReports).length,
        R.pathOr([], ['sleepReport', 'numOfAwakenings'], this.patientWithDetailedReports).length,
        R.pathOr([], ['sleepReport', 'totalSleepTimes'], this.patientWithDetailedReports).length,
        R.pathOr([], ['sleepReport', 'majorInterruptions'], this.patientWithDetailedReports).length,
      ]

      return !data.filter(Boolean).length
    },
  },
  watch: {
    async startTimestamp(n, o) {
      await this.fetchPatientWithDetailedReport({ startTime: n })
    },
    async endTimestamp(n, o) {
      await this.fetchPatientWithDetailedReport({ endTime: n })
    },
  },
  async mounted() {
    await this.fetchPatientWithDetailedReport()
    await this.fetchPatientWithStats()
    this.isInitialized = true
  },
  methods: {
    ...mapActions(ModuleNames.patientWithDetailedReports, [ActionNames.getPatientWithDetailedReportsById]),
    ...mapActions(ModuleNames.patientWithStats, [PatientWithStatsActionNames.getPatientWithStatsById]),

    async fetchPatientWithDetailedReport() {
      const lastYearTimestamp = moment()
        .add(-1, 'y')
        .startOf('day')
        .valueOf()
      await this[ActionNames.getPatientWithDetailedReportsById]({
        patientId: this.patientId,
        startTimestamp: Math.max(lastYearTimestamp, this.startTimestamp - OFFSET_HOURS_TIMESTAMP),
        endTimestamp: this.endTimestamp,
      })
    },

    async fetchPatientWithStats() {
      const lastYearTimestamp = moment()
        .add(-1, 'y')
        .startOf('day')
        .valueOf()
      await this[PatientWithStatsActionNames.getPatientWithStatsById]({
        patientId: this.patientId,
        startTimestamp: Math.max(lastYearTimestamp, this.startTimestamp - OFFSET_HOURS_TIMESTAMP),
        endTimestamp: this.endTimestamp,
      })
    },
  },
})
